// extracted by mini-css-extract-plugin
module.exports = {"platform":"AboutPlatform_platform__rgzGE","platform__important":"AboutPlatform_platform__important__tvUpa"};